import React, { useEffect, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
// import "./PatientTable.css";
import PropTypes from "prop-types";
import ClipLoader from "react-spinners/ClipLoader";
import { useTranslation } from "react-i18next";
import { t } from "i18next";

const DocumentsTable = ({documents, columns, setSelectedRow}) => {
    const gridRef = useRef(null);
    const { t } = useTranslation();

    const [allDocuments, setAllDocuments] = useState(documents)
    const [originalDocuments, setOriginalDocuments] = useState(documents)

    // const table_columns = columns.map(col => {
    //     return col.headerName !== t('seeMore') && col.headerName !== t('sendMessage')
    //         ? { ...col, filter: true, floatingFilter: true }
    //         : col;
    // });

    useEffect(() => {
        if (gridRef.current && gridRef.current.api) {
            gridRef.current.api.sizeColumnsToFit();
        }
    }, [gridRef]);

    const onFirstDataRendered = (params) => {
        params.api.sizeColumnsToFit();
    };

    const defaultColDef = {
        flex: 1,
    };


    useEffect(() => {
        const lang = t('documentsPage') === 'Documenti' ? 'it' : 'en'

        const new_documents = originalDocuments.map((doc) => {
            return {...doc, loadingDate: lang === 'it' ? doc.loadingDate.toLocaleString('it-IT') : doc.loadingDate.toLocaleString('en-GB')}
        })
        // console.log("NEW DOCUMENTS TABLE", new_documents)

        // setAllDocuments(new_documents)
        setAllDocuments(originalDocuments)
    }, [t])


    useEffect(() => {
        const lang = t('documentsPage') === 'Documenti' ? 'it' : 'en'

        // console.log("DOCUMENTS TABLE", allDocuments)

        const new_documents = allDocuments.map((doc) => {
            return {...doc, loadingDate: lang === 'it' ? doc.loadingDate.toLocaleString('it-IT') : doc.loadingDate.toLocaleString('en-GB')}
        })
        console.log("NEW DOCUMENTS TABLE", new_documents)

        // setAllDocuments(new_documents)
        setAllDocuments(allDocuments)
        setOriginalDocuments(documents)

    }, [])
    

  return (
    <div className={"ag-theme-alpine"} style={{ padding: '20px' }}>
        <AgGridReact
            ref={gridRef}
            rowData={allDocuments}
            columnDefs={columns}
            onFirstDataRendered={onFirstDataRendered}
            defaultColDef={defaultColDef}
            domLayout='autoHeight'
            onCellMouseOver={setSelectedRow}
            // gridOptions={gridOptions}
            // pagination={pagination}
            // paginationPageSize={paginationPageSize}
            // paginationPageSizeSelector={paginationPageSizeSelector}
            // onRowClicked={onRowClicked}  // Add the row click handler here
        />
    </div>
  )
}

export default DocumentsTable